<template>
  <div class="mt-5">
    <h2>Gerenciar Capítulos</h2>
    <div v-for="(chapter, index) in chapters" :key="index" class="card chapter-card mb-3">
      <div class="card-body">
        <div class="mb-3">
          <label class="form-label">Título do Capítulo</label>
          <input type="text" class="form-control" :value="chapter.title" @input="updateChapterField(index, 'title', $event.target.value)">
        </div>
        <div class="mb-3">
          <label class="form-label">Conteúdo</label>
          <textarea class="form-control" :value="chapter.content" @input="updateChapterField(index, 'content', $event.target.value)" rows="5"></textarea>
        </div>
        <button class="btn btn-danger btn-sm" @click="removeChapter(index)">Remover Capítulo</button>
      </div>
    </div>
    <button class="btn btn-vampire" @click="addChapter">Adicionar Capítulo</button>
  </div>
</template>

<script>
export default {
  name: 'ChapterManager',
  emits: ['update:chapters'],
  props: {
    chapters: {
      type: Array,
      required: true,
    },
  },
  methods: {
    addChapter() {
      const next = [...this.chapters, { title: '', content: '' }];
      this.$emit('update:chapters', next);
    },
    removeChapter(index) {
      const next = this.chapters.filter((_, i) => i !== index);
      this.$emit('update:chapters', next);
    },
    updateChapterField(index, key, value) {
      const next = this.chapters.map((chapter, i) =>
        i === index ? { ...chapter, [key]: value } : chapter
      );
      this.$emit('update:chapters', next);
    },
  },
};
</script>

<style scoped>
.chapter-card {
  background-color: var(--vampire-gray);
  border-color: var(--vampire-red);
}
</style>
